import { useState } from "react";
import { BsEye, BsEyeSlash } from "react-icons/bs";
import { Link } from "react-router-dom";

import LoadingButton from "@/components/loading-button";
import { useComponentTranslation } from "@/services/i18n";

const translations = {
  en: {
    auth: {
      sign_in: {
        email: "Email address",
        password: "Password",
        forgot_password: "Forgot password?",
        button: "Sign in",
      },
    },
  },
  fr: {
    auth: {
      sign_in: {
        email: "Adresse email",
        password: "Mot de passe",
        forgot_password: "Mot de passe oublié ?",
        button: "Se connecter",
      },
    },
  },
};

export default function SigninForm({ onSubmit, loading, job }) {
  const { t } = useComponentTranslation(translations);
  const [values, setValues] = useState({ email: "", password: "" });
  const [seePassword, setSeePassword] = useState(false);

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit(values);
      }}
      className="w-full flex flex-col gap-y-6"
    >
      <div>
        <label htmlFor="email" className="input-label">
          {t("auth.sign_in.email")}
        </label>
        <input
          type="email"
          id="email"
          name="email"
          value={values.email}
          onChange={(e) => setValues({ ...values, email: e.target.value })}
          className="input"
          placeholder="jane@example.com"
        />
      </div>

      <div>
        <div className="flex items-center justify-between mb-1.5">
          <label htmlFor="password" className="input-label mb-0">
            {t("auth.sign_in.password")}
          </label>
          <Link to="/auth/forgot" className="text-sm text-primary font-medium hover:underline">
            {t("auth.sign_in.forgot_password")}
          </Link>
        </div>
        <div className="relative">
          <input
            type={seePassword ? "text" : "password"}
            id="password"
            name="password"
            value={values.password}
            onChange={(e) => setValues({ ...values, password: e.target.value })}
            className="input pr-10"
            placeholder="••••••••"
            required
          />
          <button type="button" className="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-400 hover:text-gray-600" onClick={() => setSeePassword(!seePassword)}>
            {seePassword ? <BsEyeSlash className="h-5 w-5" /> : <BsEye className="h-5 w-5" />}
          </button>
        </div>
      </div>

      <LoadingButton loading={loading} className="btn btn-primary w-full btn-large" disabled={!values.password}>
        {t("auth.sign_in.button")}
      </LoadingButton>
    </form>
  );
}
